import { useState } from "react";
import { Link } from "react-router-dom";
import "./nav.css";
import logoLg from "../images/logo-desktop.png";
import logoSm from "../images/logo-mobile.png";

import { BiMenu } from "react-icons/bi";

const Nav = () => {
  const [showing, setShowing] = useState(false);
  return (
    <header className={showing ? "" : "no-overlay"}>
      <a href="https://jalopytheatre.org/" className="logo-image">
        <img
          src={logoLg}
          alt="Jalopy Theatre logo"
          srcSet={`${logoLg} 968w, ${logoSm} 600w`}
          sizes={`(max-width: 960px) 600px,
            904px`}
        />
      </a>
      <nav>
        <a href="https://jalopytheatre.org/" className="home">
          Home
        </a>
        <span onClick={() => setShowing(!showing)}>
          <BiMenu color="white" size="2rem" style={{ marginLeft: "1rem" }} />
        </span>
        <ul
          className={`main-nav ${showing ? "showing" : ""}`}
          onClick={() => setShowing(false)}
        >
          <Link to="/kids-classes">
            <li className="sub-nav-category">Kids Classes</li>
          </Link>
          <Link to="/classes">
            <li className="sub-nav-category">Classes</li>
          </Link>
          <Link to="/tags/guitar">
            <li className="list-item">Guitar</li>
          </Link>
          <Link to="/tags/mandolin">
            <li className="list-item">Mandolin</li>
          </Link>
          <Link to="/tags/banjo">
            <li className="list-item">Banjo</li>
          </Link>
          <Link to="/tags/fiddle">
            <li className="list-item">Fiddle</li>
          </Link>
          <Link to="/tags/ukulele">
            <li className="list-item">Ukulele</li>
          </Link>
          <Link to="/tags/singing">
            <li className="list-item">Singing</li>
          </Link>
          <Link to="/tags/harmonica">
            <li className="list-item">Harmonica</li>
          </Link>
          <Link to="/tags/writing">
            <li className="list-item">Writing</li>
          </Link>
          <Link to="/tags/performing">
            <li className="list-item">Performing</li>
          </Link>
          <Link to="/lessons">
            <li className="sub-nav-category">Private Lessons</li>
          </Link>
          <Link to="/performances">
            <li className="sub-nav-category">Performances</li>
          </Link>
          <Link to="/tags/festivals">
            <li className="list-item">Festivals</li>
          </Link>
          <Link to="/tags/adult-performances">
            <li className="list-item">Adults</li>
          </Link>
          <Link to="/tags/kids-performances">
            <li className="list-item">Kids</li>
          </Link>
          <Link to="/workshops">
            <li className="sub-nav-category">Workshops</li>
          </Link>
          <Link to="/tags/kids">
            <li className="sub-nav-category">Jalopy Junior</li>
          </Link>
        </ul>
      </nav>
      <div className="overlay" onClick={() => setShowing(false)}></div>
    </header>
  );
};

export default Nav;

/**
 * Workshops
Classes
   Guitar
   Mandolin
   Banjo
   Fiddle
   Ukulele
   Singing
   Harmonica
   Writing
   Performing
   Private Instruction
   Jalopy Junior
   Performances 
   Adult
   Kids
 */
